import { httpClient } from '@aninix/api'
import { config } from '@aninix/api/config'
import { UseMutationResult, useMutation } from '@tanstack/react-query'
import { AxiosResponse } from 'axios'
import { useParams } from 'react-router-dom'

import { Rectangle } from './use-get-comments'

export interface ICommentPostCommentResponse {
  query: UseMutationResult<
    AxiosResponse<any, any>,
    unknown,
    ICommentPostPayload,
    unknown
  >
}

export interface ICommentPostPayload {
  comment: string
  rectangle?: Rectangle
  time?: number
  parentCommentId?: string
}

const defaultRectangle: Rectangle = { x: 0, y: 0, width: 0, height: 0 }

export const usePostCommentResponse = (): ICommentPostCommentResponse => {
  const { projectId } = useParams()

  const query = useMutation({
    mutationKey: ['postProjectComment', projectId],
    mutationFn: ({
      comment,
      rectangle = defaultRectangle,
      time = 0,
      parentCommentId,
    }: ICommentPostPayload) =>
      httpClient.post(
        `${config.apiUrl}/projects/${projectId}/comments`,
        { comment, rectangle, time, parentCommentId },
        {
          responseType: 'json',
        }
      ),
  })

  return { query }
}
